module.exports = __webpack_public_path__ + "videos/39.2ddff32.mp4";